import { usePricingPlans } from '~teacher/hook/usePlanPrices';

export function useShowShowbieCompleteOffer() {
  return usePricingPlans({
    select: (data) => data.offerShowbieCompletePrice ?? false,
  });
}
